(function ($) {
    'use strict';

    const WIDGET_SELECTOR    = '.prodigy-rules-widget[data-ends-at]';
    const COUNTDOWN_SELECTOR = '.prodigy-rules-countdown-js';

    let countdownIntervalId = null;

    /**
     * Format seconds into "Xd Xh Xm" or "Xh Xm" depending on magnitude.
     *
     * @param {number} totalSeconds
     * @returns {string}
     */
    function formatCountdown(totalSeconds) {
        if (totalSeconds <= 0) {
            return '0h 0m';
        }

        const days    = Math.floor(totalSeconds / 86400);
        const hours   = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);

        if (days > 0) {
            return days + 'd ' + hours + 'h ' + minutes + 'm';
        }
        return hours + 'h ' + minutes + 'm';
    }

    function renderRuleRows($widget, rules) {
        let $list = $widget.find('.prodigy-rules-list');

        if (!rules.length) {
            return;
        }

        if (!$list.length) {
            $list = $('<div/>', { class: 'prodigy-rules-list' }).appendTo($widget.find('.prodigy-rules-content'));
        }

        $list.empty();

        const hideProgress    = $widget.attr('data-hide-progress') === '1';
        const hideCategoryName = $widget.attr('data-hide-category-name') === '1';

        rules.forEach(function (rule) {
            const categoryName    = rule['category-name'] || '';
            const capacity        = parseInt(rule['capacity'], 10) || 0;
            const orderedQuantity = parseInt(rule['ordered-quantity'], 10) || 0;
            const progress        = capacity > 0
                ? Math.min(100, Math.round((orderedQuantity / capacity) * 100))
                : 0;

            const $row = $('<div/>', { class: 'prodigy-rules-row' });
            const $info = $('<div/>', { class: 'prodigy-rules-row-info' });

            if (!hideCategoryName) {
                $('<span/>').text(categoryName + ':').appendTo($info);
            }
            $('<span/>').text(orderedQuantity + ' of ' + capacity + ' items in cart').appendTo($info);

            if (!hideProgress) {
                $('<div/>', { class: 'prodigy-rules-progress' })
                    .append($('<span/>').css('width', progress + '%'))
                    .appendTo($row);
            }

            $row.prepend($info).appendTo($list);
        });
    }

    /**
     * Start (or restart) a live countdown inside every `.prodigy-rules-widget` on
     * the page that has a valid `data-ends-at` attribute.
     */
    function startCountdown() {
        if (countdownIntervalId) {
            clearInterval(countdownIntervalId);
        }

        $(WIDGET_SELECTOR).each(function () {
            const $widget  = $(this);
            const endsAt   = $widget.attr('data-ends-at');
            const endTime  = endsAt ? new Date(endsAt).getTime() : 0;

            if (!endTime) {
                return;
            }

            countdownIntervalId = setInterval(function () {
                const remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
                $widget.find(COUNTDOWN_SELECTOR).text(formatCountdown(remaining));

                if (remaining <= 0) {
                    clearInterval(countdownIntervalId);
                }
            }, 1000);
        });
    }

    /**
     * Refresh the per-category counters and progress bars using an AJAX call.
     * Only updates the DOM — does not re-render the whole widget.
     */
    function refreshRules() {
        if (typeof settings === 'undefined' || !settings.nonce) {
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const orderId   = urlParams.get('order_id') ? parseInt(urlParams.get('order_id'), 10) : null;

        $.ajax({
            type: 'post',
            url: ajax_url,
            data: Object.assign(
                { action: 'prodigy-get-redemption-rules', nonce: settings.nonce },
                orderId ? { order_id: orderId } : {}
            ),
            dataType: 'json',
            success: function (response) {
                if (!response || !response.success || !response.data) {
                    return;
                }

                const data = response.data;

                $(WIDGET_SELECTOR).each(function () {
                    const $widget = $(this);

                    // Update ends-at data attribute so the countdown stays in sync.
                    if (data.ends_at) {
                        $widget.attr('data-ends-at', data.ends_at);
                    }

                    if (data.ends_at_label) {
                        $widget.find('.prodigy-rules__text-date').text(data.ends_at_label);
                    }

                    if (data.time_remaining) {
                        $widget.find(COUNTDOWN_SELECTOR).text(data.time_remaining);
                    }

                    // Update per-category rows.
                    const rules = data.order_rules || [];
                    renderRuleRows($widget, rules);
                });

                // Restart the countdown with the fresh end time.
                startCountdown();
            },
        });
    }

    // ── Initialisation ───────────────────────────────────────────────────────

    $(document).ready(function () {
        if (!$(WIDGET_SELECTOR).length) {
            return;
        }

        startCountdown();

        // Refresh rules when the page becomes visible again (user switched tabs,
        // added to cart in another tab, etc.).
        document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'visible') {
                refreshRules();
            }
        });
    });

    // Refresh after a successful add-to-cart so ordered-quantity counts update.
    // The add-to-cart handler in public.js dispatches a native CustomEvent on the
    // document after the AJAX call succeeds.
    $(document).on('prodigy:cart:updated', function () {
        refreshRules();
    });

}(jQuery));
